import { useState, useRef } from 'react';

import './styles.css';

import { NavLink } from 'react-router-dom';

import Estimule from '../../assets/logos/estimule_logo.svg';

import Hamburguer from '../Hamburguer';
import Sidebar from '../Sidebar';

const Navbar = ({ toggleHamburger }) => {
  return (
    <>
      <div className="navbar-container">
        <div className="navbar-logo-container">
          <NavLink to="/">
            <img src={Estimule}></img>
          </NavLink>
        </div>
        <div className="navbar-navigation-container">
          <nav className="desktop-menu">
            <NavLink to="/" className="nav-item">
              Página inicial
            </NavLink>
            <NavLink to="/filter" className="nav-item">
              Filtro
            </NavLink>
            <NavLink to="/manual" className="nav-item">
              Manual
            </NavLink>
            <NavLink to="sugestoes" className="nav-item">
              Sugestões
            </NavLink>
          </nav>
          <div className="mobile-menu" onClick={toggleHamburger}>
            <Hamburguer ></Hamburguer>
          </div>
        </div>
      </div>
    </>
  );
};

export default Navbar;
